import React from 'react';
import FacebookIcon from '../../../assets/logos/facebook';
import TwitterIcon from '../../../assets/logos/twitter';
import InstagramIcon from '../../../assets/logos/instagram';
import LinkedInIcon from '../../../assets/logos/linked-in';
import { Color } from '../../../styles/colors';
const items = [
  {
    icon: FacebookIcon,
    href: 'https://www.facebook.com/BlinkHealth',
  },
  {
    icon: TwitterIcon,
    href: 'https://twitter.com/blinkhealth',
  },
  {
    icon: InstagramIcon,
    href: 'https://www.instagram.com/blinkhealth',
  },
  {
    icon: LinkedInIcon,
    href: 'https://www.linkedin.com/company/blink-health',
  },
];

const SocialIcons = () => (
  <div className="d-sm-flex justify-content-start">
    {items.map(({ icon: Icon, href }) => (
      <a key={href} href={href} target="_blank" rel="noopener noreferrer">
        <Icon color={Color.tertiary100} />
      </a>
    ))}
  </div>
);

export default SocialIcons;
